var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconToken(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 54.118,
    viewBox: "0 0 120 54.118",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5810",
    "data-name": "Grupo 5810",
    transform: "translate(-2.5 -28.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4523",
    "data-name": "Caminho 4523",
    d: "M99.2,50.6v-9.61a12.464,12.464,0,0,0-24.927,0V50.6a18.458,18.458,0,1,0,30.874,13.656A18.045,18.045,0,0,0,99.2,50.6ZM78.07,40.992a8.731,8.731,0,0,1,17.462,0v6.954a17.884,17.884,0,0,0-17.462,0ZM86.8,79.051a14.794,14.794,0,1,1,14.8-14.794A14.818,14.818,0,0,1,86.8,79.051Z",
    transform: "translate(17.347 0)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4524",
    "data-name": "Caminho 4524",
    d: "M88.628,53.119,83.06,58.687,80.277,55.9a1.879,1.879,0,0,0-2.657,2.657L81.8,62.736a1.835,1.835,0,0,0,2.531,0l6.959-6.959a1.879,1.879,0,0,0-2.657-2.657Z",
    transform: "translate(19.695 6.328)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4525",
    "data-name": "Caminho 4525",
    d: "M27.5,47.355a1.843,1.843,0,0,0-2.531-.633l-3.543,2.025V44.7a1.9,1.9,0,1,0-3.8,0v4.049l-3.543-2.025a1.845,1.845,0,0,0-1.9,3.163L15.73,51.91l-3.543,2.025A1.838,1.838,0,0,0,13.2,57.351a2.346,2.346,0,0,0,.886-.253l3.543-2.025v4.049a1.9,1.9,0,1,0,3.8,0V55.074L24.967,57.1a2.346,2.346,0,0,0,.886.253,2.163,2.163,0,0,0,1.645-.886,1.843,1.843,0,0,0-.633-2.531L23.322,51.91l3.543-2.025A1.843,1.843,0,0,0,27.5,47.355Z",
    transform: "translate(2.334 3.749)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4526",
    "data-name": "Caminho 4526",
    d: "M46.3,47.355a1.843,1.843,0,0,0-2.531-.633l-3.543,2.025V44.7a1.9,1.9,0,0,0-3.8,0v4.049l-3.543-2.025a1.845,1.845,0,0,0-1.9,3.163L34.53,51.91l-3.543,2.025A1.838,1.838,0,0,0,32,57.351a2.346,2.346,0,0,0,.886-.253l3.543-2.025v4.049a1.9,1.9,0,1,0,3.8,0V55.074L43.767,57.1a2.346,2.346,0,0,0,.886.253,2.163,2.163,0,0,0,1.645-.886,1.843,1.843,0,0,0-.633-2.531L42.122,51.91l3.543-2.025A1.743,1.743,0,0,0,46.3,47.355Z",
    transform: "translate(7.294 3.749)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4527",
    "data-name": "Caminho 4527",
    d: "M65.2,47.355a1.843,1.843,0,0,0-2.531-.633l-3.543,2.025V44.7a1.9,1.9,0,1,0-3.8,0v4.049l-3.543-2.025a1.845,1.845,0,0,0-1.9,3.163L53.43,51.91l-3.543,2.025A1.838,1.838,0,0,0,50.9,57.351a2.346,2.346,0,0,0,.886-.253l3.543-2.025v4.049a1.9,1.9,0,1,0,3.8,0V55.074L62.667,57.1a2.346,2.346,0,0,0,.886.253,2.163,2.163,0,0,0,1.645-.886,1.843,1.843,0,0,0-.633-2.531L60.9,51.91l3.543-2.025A1.884,1.884,0,0,0,65.2,47.355Z",
    transform: "translate(12.289 3.749)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4528",
    "data-name": "Caminho 4528",
    d: "M86.392,37.2a1.945,1.945,0,0,0-1.9-1.9H13.129A10.606,10.606,0,0,0,2.5,45.918v15.8A10.606,10.606,0,0,0,13.129,72.336h66.3a1.9,1.9,0,1,0,0-3.792h-66.3a7.018,7.018,0,0,1-6.959-6.952V45.918a7.018,7.018,0,0,1,6.959-6.952H84.494A1.838,1.838,0,0,0,86.392,37.2Z",
    transform: "translate(0 1.778)",
    fill: "#4b4b4b"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconToken);
export default __webpack_public_path__ + "static/media/icon_token.f59670f8.svg";
export { ForwardRef as ReactComponent };